/**
 * 浏览器端图片处理调试日志（默认关闭；仅 Agent 控制台查看 Sidecar 调用记录）。
 * 设 REACT_APP_IPE_IMAGE_PROCESS_LOG=true 可临时开启。
 */
const ENABLED = process.env.REACT_APP_IPE_IMAGE_PROCESS_LOG === 'true';

function truncateUrl(url) {
  const text = String(url || '').trim();
  if (text.length <= 120) return text;
  return `${text.slice(0, 117)}...`;
}

/**
 * @param {'enhance'|'cutout'|'detection'|'lingtu'} service
 * @param {string} stage submit|poll|done|failed|progress
 * @param {Record<string, unknown>} [payload]
 */
export function logImageProcess(service, stage, payload = {}) {
  if (!ENABLED) return;
  const safe = { ...payload };
  if (safe.imageUrl) safe.imageUrl = truncateUrl(safe.imageUrl);
  if (safe.url) safe.url = truncateUrl(safe.url);
  console.info(`[IPE:${service}] ${stage}`, safe);
}
